import { render, staticRenderFns } from "./PalavraComponent.vue?vue&type=template&id=34cf19bc&scoped=true"
import script from "./PalavraComponent.vue?vue&type=script&lang=js"
export * from "./PalavraComponent.vue?vue&type=script&lang=js"
import style0 from "./PalavraComponent.vue?vue&type=style&index=0&id=34cf19bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf19bc",
  null
  
)

export default component.exports